<template>
  <div>
    <div class="border">
      <h5 class="mb-4">
        {{
          "cert_created_success" | setText("Сертификат успешно сгенерирован")
        }}
      </h5>

      <h4>
        {{
          "only_14_days_for_cancel_2"
            | setText(
              "Распечатайте сертификат поставьте подпись и выдайте его клиенту"
            )
        }}
      </h4>
      <button target="_blank" class="btn btn-default mw" @click="getPdf">
        {{ "download_cert" | setText("скачать сертификат") }}
      </button>
      <div v-if="link_cert">
        <br />
        Прямая ссылка:
        <a ref="link_cert" target="_blank" class="link" :href="link_cert"
          >Скачать</a
        >
      </div>

      <div class="mt-4">
        <button @click="close" class="btn btn-info mw">В заказ</button>
      </div>
    </div>

    <div class="border" v-if="!data.is_compensation">
      <h4>
        {{
          "client_coming_get_compensation"
            | setText("Клиент пришел получить компенсацию?")
        }}
      </h4>
      <button class="btn btn-info mw" @click="checkRequest">
        {{ "yes_check_data" | setText("ДА, СВЕРИТЬ ДАННЫЕ") }}
      </button>

      <modal name="compensation" v-if="cartificate">
        <card>
          <h4>{{ "query_compensation" | setText("Запрос на компенацию") }}</h4>
          <ul>
            <li>
              <b>{{ "cert" | setText("Сертификат") }}:</b>
              {{ cartificate.CertificateID }}
            </li>
            <li>
              <b>{{ "first_name_buyer" | setText("Имя покупателя") }}:</b>
              {{ cartificate.FirstNameBuyer }}
            </li>
            <li>
              <b>{{ "last_name_buyer" | setText("Фамилия покупателя") }}:</b>
              {{ cartificate.LastNameBuyer }}
            </li>
            <li>
              <b
                >{{
                  "product_venodr" | setText("Производитель устройства")
                }}:</b
              >
              {{ cartificate.DeviceBrand }}
            </li>
            <li>
              <b>Товар:</b>
              {{ cartificate.DeviceModel }}
            </li>
            <li><b>IMEI:</b> {{ cartificate.DeviceIMEI }}</li>
          </ul>

          <button class="btn btn-info mt-4" @click="checkStatus">
            {{ "get_compensation" | setText("Получить компенацию") }}
          </button>
        </card>
      </modal>
    </div>

    <div class="border" v-if="$store.state.user['is_root']">
      <h4>
        {{
          "only_14_days_for_cancel_2"
            | setText(
              "Распечатайте сертификат поставьте подпись и выдайте его клиенту"
            )
        }}
      </h4>
      <button class="btn btn-info btn-danger mw" @click="cancelRequest">
        {{ "cencel_cert" | setText("Отменить сертификат") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);

      if (query["item_order_service"]) {
        delete query["item_order_service"];
      }
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },

    async getPdf() {
      this.$loading(true);
      const token = this.data.service.api_token;
      return this.$http({
        method: "get",
        url: `https://api.mobile.com.kz/api/CertificateSale/PrintForm?certificateId=${this.data.exchange_id}&series=UC`,
        headers: {
          "X-Access-Token": `${token}`,
          "Content-Type": `application/json`,
        },
      })
        .then(async (response) => {
          this.link_cert = await response.data.url;

          //click a link link_cert refs
          setTimeout(() => {
            this.$refs.link_cert.click();
          }, 100);
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async cancelRequest() {
      this.$dialog
        .confirm("Вы точно хотите отменить сертификат?", {
          okText: this.$store.state.text.continue,
          cancelText: this.$store.state.text.cancel,
        })
        .then(() => {
          this.$loading(true);
          const action = `Certificates/Return`;
          const url = this.data.service.api_endpoint_url + action;
          const token = this.data.service.api_token;
          const method = "post";
          const data = {
            CertificateID: this.data.exchange_id,
            Series: "UC",
            Shop_id: "22",
          };
          logger(this.$http, {
            name: "Отмена заявки - запрос в keeptok",
            url: url,
            method: method,
          });
          return this.$http({
            method: method,
            data: data,
            url: url,
            headers: {
              "X-Access-Token": `${token}`,
              "Content-Type": `application/json`,
            },
          })
            .then((response) => {
              const data = response.data;
              this.$emit("input", {
                is_paid: 0,
                state: "cancel",
              });
              return response.data;
            })
            .catch((error) => {
              this.$loading(false);
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
    async checkRequest() {
      this.$dialog
        .confirm(
          "Вы получили успешный статус в телелеграм бот от сервиса KEEPTOK?",
          {
            okText: this.$store.state.text.continue,
            cancelText: this.$store.state.text.cancel,
          }
        )
        .then(() => {
          this.$loading(true);
          const action = `Certificates/Partner/Search`;
          const url = this.data.service.api_endpoint_url + action;
          const token = this.data.service.api_token;
          const method = "post";
          const data = {
            CertificateID: this.data.exchange_id,
            Series: "UC",
          };
          logger(this.$http, {
            name: "Сверка заявки - запрос в keeptok",
            url: url,
            method: method,
          });
          return this.$http({
            method: method,
            data: data,
            url: url,
            headers: {
              "X-Access-Token": `${token}`,
              "Content-Type": `application/json`,
            },
          })
            .then((response) => {
              if (response.data.CertificateID) this.cartificate = response.data;

              if (response.data.message) {
                this.$notify({
                  title: "KEEPTALK",
                  message: response.data.message,
                  icon: "ti-close",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                });
              }

              setTimeout(() => {
                this.$modal.show("compensation");
              }, 100);
            })
            .catch((error) => {
              alert("Ошибка партнера");
              return errorNotify(error, this.notify);
            })
            .finally(() => {
              this.$loading(false);
            });
        })
        .catch(() => {});
    },
    async checkStatus() {
      this.$dialog
        .confirm(
          "Вы точно хотите сформировать запрос на получение компенсации?",
          {
            okText: this.$store.state.text.continue,
            cancelText: this.$store.state.text.cancel,
          }
        )
        .then(() => {
          this.$loading(true);
          const action = `Certificates/Status`;
          const url = this.data.service.api_endpoint_url + action;
          const token = this.data.service.api_token;
          const method = "post";

          const data = {
            CertificateID: this.data.exchange_id,
            Series: "UC",
            DeviceIMEI: this.data.code,
          };

          return this.$http({
            method: method,
            data: data,
            url: url,
            headers: {
              "X-Access-Token": `${token}`,
              "Content-Type": `application/json`,
            },
          })
            .then((response) => {
              //0 - не найдено
              //1 - создано
              //2 - просроченный
              //3 - обмененный
              //4 - пользователь вернул сервис
              //5 - одобрено
              //6 - отказанно
              //7 - на уточнении
              try {
                let status = response.data.Status;
                if (status == 5 || status == 3) {
                  this.doneRequest();
                } else {
                  let msg = "";
                  if (status == 0) {
                    msg = "Сертификат не найден";
                  } else if (status == 1) {
                    msg =
                      'Сервис был создан или продан в системе; статус назначается после запроса "sale".';
                  } else if (status == 2) {
                    msg = "Срок действия сервиса истек";
                  } else if (status == 4) {
                    msg = "Сервис был возвращен";
                  } else if (status == 6) {
                    msg = "Было отказано в выплате компенсации по сертификату";
                  } else if (status == 7) {
                    msg =
                      "Идет запрос и обработка дополнительных деталей по сертификату, необходимых для принятия решения (одобрить или отказать).";
                  }
                  this.$notify({
                    title: "KEEPTALK",
                    message: msg,
                    icon: "ti-close",
                    horizontalAlign: "right",
                    verticalAlign: "top",
                  });
                }
              } catch (error) {}

              console.log();
            })
            .catch((error) => {
              alert("Ошибка партнера");
              return errorNotify(error, this.notify);
            })
            .finally(() => {
              this.$loading(false);
            });
        })
        .catch(() => {});
    },
    async doneRequest() {
      this.$loading(true);
      const action = `Certificates/Partner/Approve`;
      const url = this.data.service.api_endpoint_url + action;
      const token = this.data.service.api_token;
      const method = "post";
      const data = {
        CertificateID: this.data.exchange_id,
        Series: "UC",
        Approved: true,
        ShopBranch_id: this.data.shop.id,
      };
      logger(this.$http, {
        name: "Получение компенсации - запрос в keeptok",
        url: url,
        method: method,
      });
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: {
          "X-Access-Token": `${token}`,
          "Content-Type": `application/json`,
        },
      })
        .then((response) => {
          if (response.data.message) {
            this.$notify({
              title: "KEEPTALK",
              message: response.data.message,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }

          if (response.data.CompensationAmount) {
            this.$emit("input", {
              is_compensation: 1,
              price_compensation: response.data.CompensationAmount,
              link: response.data.CertificateUrl,
            });

            setTimeout(() => {
              this.$modal.hide("compensation");
            }, 100);
          }
        })
        .catch((error) => {
          this.$loading(false);
          alert("Ошибка партнера");
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data: () => ({
    cartificate: null,
    link_cert: "",
  }),
  props: ["value", "data"],
};
</script>
